module.exports = __webpack_public_path__ + "static/media/cameraClick.436f57e8.mp3";